export default (str, decoder?, charset?) => {
  const strWithoutPlus = str.replace(/\+/g, ' ');
  if (charset === 'iso-8859-1') {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }

  if (/^(\d+|\d*\.\d+)$/.test(str)) {
    if (/^0\d/.test(str)) {
      return decodeURIComponent(strWithoutPlus);
    }
    return Number(str);
  }

  const keywords = {
    true: true,
    false: false,
    null: null,
    undefined: undefined,
  };

  if (str in keywords) {
    return keywords[str];
  }

  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
